import { ref as b, computed as M, onMounted as Q, openBlock as s, createElementBlock as n, normalizeClass as w, Fragment as P, renderList as se, onUnmounted as oe, resolveComponent as X, createBlock as B, withCtx as $, toDisplayString as y, createCommentVNode as h, renderSlot as _, useModel as z, createVNode as S, createElementVNode as a, unref as g, mergeModels as I, watch as ve, resolveDynamicComponent as Se, inject as K, createTextVNode as N, withModifiers as E, toValue as F, useTemplateRef as H, withKeys as j, withDirectives as ee, vShow as de, nextTick as pe, vModelText as Ce } from "vue";
import { UseColorMode as ne } from "@vueuse/components";
import { Info as xe, ShieldUser as Te, UsersRound as Oe, Settings as Be, ScanFace as Me, KeySquare as Pe, CircleUser as Ae, SlidersHorizontal as Le, Slash as Ne, MonitorCheck as Ee, List as ze, Grid3X3 as De, Moon as Fe, Sun as Ie, LucideMenu as Ve, LucideX as Re, LucideLoaderCircle as W, LucideEye as Ge, LucideEyeOff as Ue, LucideExternalLink as qe, LucideSearch as We } from "@lucide/vue";
import { NavigationButton as Ke } from "@2fauth/formcontrols";
import { useNotification as He } from "@kyvg/vue3-notification";
import { useClipboard as me } from "@vueuse/core";
import { createI18n as je } from "vue-i18n";
const Qe = ["data-is-active"], Xe = {
  __name: "Dots",
  props: {
    stepCount: {
      type: Number,
      default: 10
    },
    initialIndex: {
      type: Number,
      default: null
    },
    period: {
      // Used only to identify the dots component when accessed using refs
      type: Number,
      default: null
    },
    isCondensed: {
      type: Boolean
    }
  },
  setup(t, { expose: l }) {
    const c = t, i = b(0), f = M(() => i.value == -1);
    function p(e) {
      i.value = e < c.stepCount ? e + 1 : 1;
    }
    function r() {
      i.value = -1;
    }
    return Q(() => {
      isNaN(c.initialIndex) || p(c.initialIndex);
    }), l({
      turnOn: p,
      turnOff: r,
      props: c
    }), (e, o) => (s(), n("ul", {
      class: w(["dots", { off: f.value, condensed: t.isCondensed }])
    }, [
      (s(!0), n(P, null, se(t.stepCount, (u) => (s(), n("li", {
        key: u,
        "data-is-active": u == i.value ? !0 : null
      }, null, 8, Qe))), 128))
    ], 2));
  }
}, Je = {
  __name: "DotsController",
  props: {
    step_count: {
      type: Number,
      default: 10
    },
    period: {
      type: Number,
      default: 30
    },
    generated_at: Number,
    autostart: {
      type: Boolean,
      default: !0
    }
  },
  emits: ["stepping-started", "stepping-ended", "stepped-up"],
  setup(t, { expose: l, emit: c }) {
    const i = t, f = b(null), p = b(null), r = b(null), e = b(null), o = b(null), u = M(() => f.value % i.period), m = M(() => i.period - u.value), d = M(() => i.period / i.step_count), T = M(() => {
      let A = u.value * i.step_count / i.period;
      return Math.floor(A) + 0;
    }), O = c, V = (A = 0) => {
      C(), f.value = A != 0 ? A : i.generated_at, O("stepping-started", T.value), o.value = T.value, p.value = setTimeout(function() {
        C(), O("stepping-ended");
      }, m.value * 1e3);
      let L = Math.ceil(u.value / d.value) * d.value - u.value;
      r.value = setTimeout(function() {
        L > 0 && (o.value += 1, O("stepped-up", o.value)), e.value = setInterval(function() {
          o.value += 1, O("stepped-up", o.value);
        }, d.value * 1e3);
      }, L * 1e3);
    }, C = () => {
      clearTimeout(p.value), clearTimeout(r.value), clearInterval(e.value), o.value = f.value = null;
    };
    return Q(() => {
      i.autostart == !0 && V();
    }), oe(() => {
      C();
    }), l({
      startStepping: V,
      reset: C,
      props: i
    }), (A, L) => (s(), n("div"));
  }
}, Ye = {
  key: 0,
  class: "title"
}, Ze = {
  key: 1,
  id: "punchline",
  class: "block"
}, Ls = {
  __name: "FormWrapper",
  props: {
    title: {
      type: String,
      default: ""
    },
    punchline: {
      type: String,
      default: ""
    }
  },
  setup(t) {
    return (l, c) => {
      const i = X("ResponsiveWidthWrapper");
      return s(), B(i, null, {
        default: $(() => [
          t.title ? (s(), n("h1", Ye, y(l.$t(t.title)), 1)) : h("", !0),
          t.punchline ? (s(), n("div", Ze, y(l.$t(t.punchline)), 1)) : h("", !0),
          _(l.$slots, "default")
        ]),
        _: 3
      });
    };
  }
}, et = {
  key: 0,
  id: "groupSwitch"
}, tt = { class: "columns is-centered m-0" }, st = { class: "column is-one-third-tablet is-one-quarter-desktop is-one-quarter-widescreen is-one-quarter-fullhd" }, ot = { class: "columns is-multiline m-0" }, nt = { class: "column is-full" }, at = { class: "column is-full" }, it = {
  key: 0,
  class: "column is-full"
}, lt = {
  key: 1,
  class: "column is-full"
}, rt = { class: "column has-text-centered" }, ut = {
  key: 0,
  class: "column is-full"
}, ct = ["onClick"], dt = {
  key: 0,
  class: "columns is-centered mt-0"
}, pt = { class: "column has-text-centered" }, Ns = {
  __name: "GroupSwitch",
  props: /* @__PURE__ */ I({
    groups: Array,
    useShare: {
      type: Boolean,
      default: !1
    }
  }, {
    activeGroup: {},
    activeGroupModifiers: {},
    isVisible: {},
    isVisibleModifiers: {}
  }),
  emits: /* @__PURE__ */ I(["active-group-changed"], ["update:activeGroup", "update:isVisible"]),
  setup(t, { emit: l }) {
    const c = z(t, "activeGroup"), i = z(t, "isVisible"), f = l;
    function p(r) {
      i.value = !1, c.value = r, f("active-group-changed", r);
    }
    return (r, e) => {
      const o = X("StackLayout");
      return i.value ? (s(), n("div", et, [
        S(o, { "should-grow": !1 }, {
          content: $(() => [
            a("div", tt, [
              a("div", st, [
                a("div", ot, [
                  S(g(ne), null, {
                    default: $(({ mode: u }) => [
                      a("div", nt, [
                        a("button", {
                          type: "button",
                          class: w(["button is-fullwidth", { "is-dark has-text-light is-outlined": u == "dark" }]),
                          onClick: e[0] || (e[0] = (m) => p(0))
                        }, y(r.$t("label.all_accounts")), 3)
                      ]),
                      a("div", at, [
                        a("button", {
                          type: "button",
                          class: w(["button is-fullwidth", { "is-dark has-text-light is-outlined": u == "dark" }]),
                          onClick: e[1] || (e[1] = (m) => p(-1))
                        }, y(r.$t("label.group_less_accounts")), 3)
                      ]),
                      t.useShare ? (s(), n("div", it, [
                        a("button", {
                          type: "button",
                          class: w(["button is-fullwidth", { "is-dark has-text-light is-outlined": u == "dark" }]),
                          onClick: e[2] || (e[2] = (m) => p(-2))
                        }, y(r.$t("label.accounts_I_m_sharing")), 3)
                      ])) : h("", !0),
                      t.useShare ? (s(), n("div", lt, [
                        a("button", {
                          type: "button",
                          class: w(["button is-fullwidth", { "is-dark has-text-light is-outlined": u == "dark" }]),
                          onClick: e[3] || (e[3] = (m) => p(-3))
                        }, y(r.$t("label.accounts_shared_with_me")), 3)
                      ])) : h("", !0),
                      a("div", rt, y(r.$t("message.or_filter_by_group")), 1),
                      (s(!0), n(P, null, se(t.groups, (m) => (s(), n(P, {
                        key: m.id
                      }, [
                        m.id > 0 ? (s(), n("div", ut, [
                          a("button", {
                            type: "button",
                            class: w(["button is-fullwidth", { "is-dark has-text-light is-outlined": u == "dark" }]),
                            onClick: (d) => p(m.id)
                          }, y(m.name), 11, ct)
                        ])) : h("", !0)
                      ], 64))), 128))
                    ]),
                    _: 1
                  })
                ]),
                r.$slots.default ? (s(), n("div", dt, [
                  a("div", pt, [
                    _(r.$slots, "default")
                  ])
                ])) : h("", !0)
              ])
            ])
          ]),
          _: 3
        })
      ])) : h("", !0);
    };
  }
}, Es = {
  __name: "Kicker",
  props: {
    kickAfter: {
      type: Number,
      required: !0
    }
  },
  emits: ["kicked"],
  setup(t, { emit: l }) {
    const c = l, i = b(["mousedown", "scroll", "keypress"]), f = b(null), p = t;
    ve(
      () => p.kickAfter,
      () => {
        o();
      }
    ), Q(() => {
      i.value.forEach(function(m) {
        window.addEventListener(m, o);
      }, this), r();
    }), oe(() => {
      i.value.forEach(function(m) {
        window.removeEventListener(m, o);
      }, this), u();
    });
    function r() {
      f.value = setTimeout(e, p.kickAfter * 60 * 1e3);
    }
    async function e() {
      clearTimeout(f.value), c("kicked");
    }
    function o() {
      u(), r();
    }
    function u() {
      clearTimeout(f.value);
    }
    return () => {
    };
  }
}, ft = {
  __name: "LucideGenericIcon",
  props: {
    name: {
      type: String,
      required: !0
    },
    size: Number,
    color: String,
    strokeWidth: Number,
    defaultClass: String
  },
  setup(t) {
    const l = { Sun: Ie, Moon: Fe, Grid3X3: De, List: ze, MonitorCheck: Ee, Slash: Ne, SlidersHorizontal: Le, CircleUser: Ae, KeySquare: Pe, ScanFace: Me, Settings: Be, UsersRound: Oe, ShieldUser: Te, Info: xe }, c = t, i = M(() => l[c.name]);
    return (f, p) => (s(), B(Se(i.value), {
      size: t.size,
      color: t.color,
      "stroke-width": t.strokeWidth,
      "default-class": t.defaultClass
    }, null, 8, ["size", "color", "stroke-width", "default-class"]));
  }
}, he = () => {
  const { notify: t } = He();
  return {
    info: (e) => {
      t({ type: "is-info", ...e });
    },
    success: (e) => {
      t({ type: "is-success", ...e });
    },
    warn: (e) => {
      t({ type: "is-warning", ...e });
    },
    alert: (e) => {
      t({ type: "is-danger", ...e });
    },
    action: (e) => {
      t({ type: "is-dark", ...e });
    },
    clear: () => {
      t({ clean: !0 });
    }
  };
}, vt = {
  key: 0,
  class: "columns is-gapless mb-3"
}, mt = { class: "column has-text-centered" }, ht = { class: "field is-grouped" }, yt = { class: "content has-text-centered" }, kt = {
  key: 0,
  class: "columns is-gapless"
}, gt = { class: "column has-text-centered" }, _t = ["inert"], $t = {
  key: 1,
  class: "submenu content has-text-centered mb-4"
}, bt = { class: "ml-0 mt-1" }, wt = { class: "column" }, St = {
  key: 0,
  class: "column"
}, Ct = {
  key: 0,
  class: "release-flag"
}, xt = {
  key: 1,
  class: "column"
}, Tt = { class: "content has-text-centered" }, Ot = { key: 0 }, Bt = {
  key: 0,
  class: "has-text-weight-bold"
}, Mt = {
  key: 1,
  class: ""
}, Pt = { key: 1 }, At = { key: 1 }, Lt = { key: 0 }, Nt = {
  key: 0,
  class: "release-flag"
}, Et = { key: 1 }, zt = { key: 2 }, Dt = { class: "mr-2 has-ellipsis" }, te = {
  __name: "VueFooterContent",
  props: {
    showMenu: {},
    showMenuModifiers: {}
  },
  emits: ["update:showMenu"],
  setup(t) {
    const l = z(t, "showMenu");
    l.value = !1;
    const c = K("appSettingsStore", {
      latestRelease: null,
      checkForUpdate: !0
    }), i = K("userStore", {
      isAdmin: !1,
      isAuthenticated: !1,
      email: null,
      preferences: {
        showEmailInFooter: !0
      },
      logout: function() {
      }
    }), f = K("2fauth", {
      context: "webapp",
      version: "x.y.z",
      config: {
        proxyAuth: !1,
        proxyLogoutUrl: null
      }
    }), p = M(() => c.latestRelease && c.checkForUpdate), r = M(() => !f.config.proxyAuth || f.config.proxyAuth && f.config.proxyLogoutUrl);
    function e(o) {
      confirm(o) && i.logout();
    }
    return (o, u) => {
      const m = X("router-link");
      return g(f).context == "webext" ? (s(), n(P, { key: 0 }, [
        o.$slots.default ? (s(), n("div", vt, [
          a("div", mt, [
            a("div", ht, [
              _(o.$slots, "default")
            ])
          ])
        ])) : h("", !0),
        a("div", yt, [
          _(o.$slots, "subpart")
        ])
      ], 64)) : g(f).context == "webapp" ? (s(), n(P, { key: 1 }, [
        o.$slots.default ? (s(), n("div", kt, [
          a("div", gt, [
            a("div", {
              class: "field is-grouped",
              inert: l.value
            }, [
              _(o.$slots, "default")
            ], 8, _t)
          ])
        ])) : h("", !0),
        l.value ? (s(), n("div", $t, [
          _(o.$slots, "submenu", {}, () => [
            a("ul", bt, [
              a("li", wt, [
                S(m, {
                  id: "lnkSettings",
                  to: { name: "settings.options" },
                  class: "is-link"
                }, {
                  default: $(() => [
                    N(y(o.$t("link.settings")), 1)
                  ]),
                  _: 1
                })
              ]),
              g(i).isAdmin ? (s(), n("li", St, [
                S(m, {
                  id: "lnkAdmin",
                  to: { name: "admin.appSetup" },
                  class: "is-link"
                }, {
                  default: $(() => [
                    p.value ? (s(), n("span", Ct)) : h("", !0),
                    N(" " + y(o.$t("link.admin_panel")), 1)
                  ]),
                  _: 1
                })
              ])) : h("", !0),
              r.value ? (s(), n("li", xt, [
                S(g(ne), null, {
                  default: $(({ mode: d }) => [
                    a("button", {
                      type: "button",
                      id: "lnkSignOut",
                      class: w(["button is-text is-like-text", d == "dark" ? "has-text-grey-lighter" : "has-text-grey-darker"]),
                      onClick: u[0] || (u[0] = (T) => e(o.$t("confirmation.logout")))
                    }, y(o.$t("label.sign_out")), 3)
                  ]),
                  _: 1
                })
              ])) : h("", !0)
            ])
          ])
        ])) : h("", !0),
        a("div", Tt, [
          _(o.$slots, "subpart", {}, () => [
            o.$route.meta.showAbout === !0 ? (s(), n("div", Ot, [
              o.$route.name != "about" ? (s(), B(m, {
                key: 0,
                id: "lnkAbout",
                to: { name: "about" },
                class: "has-text-grey"
              }, {
                default: $(() => [
                  g(i).isAuthenticated && o.$route.meta.watchedByKicker ? (s(), n("span", Bt, "2FAuth – v" + y(g(f).version), 1)) : (s(), n("span", Mt, y(o.$t("link.about")), 1))
                ]),
                _: 1
              })) : (s(), n("span", Pt, " "))
            ])) : g(i).preferences.showEmailInFooter == !1 ? (s(), n("div", At, [
              S(m, {
                id: "lnkSettings",
                to: { name: "settings.options" },
                class: "has-text-grey"
              }, {
                default: $(() => [
                  N(y(o.$t("link.settings")), 1)
                ]),
                _: 1
              }),
              g(i).isAdmin ? (s(), n("span", Lt, [
                u[3] || (u[3] = N(" - ", -1)),
                S(m, {
                  id: "lnkAdmin",
                  to: { name: "admin.appSetup" },
                  class: "has-text-grey"
                }, {
                  default: $(() => [
                    N(y(o.$t("link.admin_panel")), 1),
                    p.value ? (s(), n("span", Nt)) : h("", !0)
                  ]),
                  _: 1
                })
              ])) : h("", !0),
              r.value ? (s(), n("span", Et, [
                u[4] || (u[4] = N(" - ", -1)),
                a("button", {
                  type: "button",
                  id: "lnkSignOut",
                  class: "button is-text is-like-text has-text-grey",
                  onClick: u[1] || (u[1] = (d) => e(o.$t("confirmation.logout")))
                }, y(o.$t("label.sign_out")), 1)
              ])) : h("", !0)
            ])) : (s(), n("div", zt, [
              a("button", {
                type: "button",
                id: "btnEmailMenu",
                onClick: u[2] || (u[2] = (d) => l.value = !l.value),
                class: "button is-text is-like-text has-text-grey",
                style: { width: "100%" }
              }, [
                a("span", Dt, y(g(i).email), 1),
                l.value ? (s(), B(g(Re), { key: 1 })) : (s(), B(g(Ve), { key: 0 }))
              ])
            ]))
          ])
        ])
      ], 64)) : h("", !0);
    };
  }
}, Ft = { class: "modal-card is-flex-grow-1" }, It = { class: "modal-card-body modal-slot py-0 is-align-content-center has-text-centered" }, Vt = { class: "modal-card-foot is-flex-direction-column main toto" }, Rt = { key: 1 }, zs = {
  __name: "Modal",
  props: /* @__PURE__ */ I({
    modelValue: Boolean,
    isFullHeight: {
      type: Boolean,
      default: !1
    }
  }, {
    isActive: {},
    isActiveModifiers: {},
    showFooterMenu: {},
    showFooterMenuModifiers: {}
  }),
  emits: ["update:isActive", "update:showFooterMenu"],
  setup(t) {
    const l = z(t, "isActive"), c = z(t, "showFooterMenu");
    function i(f) {
      he().clear(), l.value = !1;
    }
    return (f, p) => {
      const r = X("router-link");
      return s(), n("div", {
        class: w(["modal modal-otp", { "is-active": l.value }])
      }, [
        a("div", {
          class: "modal-background",
          onClick: E(i, ["stop"])
        }),
        a("div", Ft, [
          a("section", It, [
            _(f.$slots, "default")
          ]),
          c.value == !0 ? (s(), n("div", {
            key: 0,
            onClick: p[0] || (p[0] = (e) => c.value = !1),
            class: "footer-overlay"
          })) : h("", !0),
          a("footer", Vt, [
            S(g(te), {
              "show-menu": c.value,
              "onUpdate:showMenu": p[1] || (p[1] = (e) => c.value = e)
            }, {
              default: $(() => [
                S(g(Ke), {
                  action: "close",
                  useLinkTag: !1,
                  onClosed: i
                })
              ]),
              submenu: $(() => [
                _(f.$slots, "footer-submenu")
              ]),
              subpart: $(() => [
                _(f.$slots, "footer-subpart", {}, () => [
                  f.$route.name != "accounts" ? (s(), B(r, {
                    key: 0,
                    id: "lnkBackToHome",
                    to: { name: "accounts" },
                    class: "has-text-grey"
                  }, {
                    default: $(() => [
                      N(y(f.$t("link.back_to_home")), 1)
                    ]),
                    _: 1
                  })) : (s(), n("span", Rt, " "))
                ])
              ]),
              _: 3
            }, 8, ["show-menu"])
          ])
        ])
      ], 2);
    };
  }
}, ye = je({
  legacy: !1,
  locale: "en",
  fallbackLocale: "en",
  globalInjection: !0
});
function fe(t, l, c, i, f) {
  t || (t = "");
  var p = String(F(t));
  const r = () => {
    const o = F(c);
    if (p.length > 0) {
      const u = Math.ceil(o < 1 ? p.length * o : o), m = p.match(new RegExp(`.{1,${u}}`, "g"));
      m && (p = m.join(" "));
    }
  }, e = () => {
    p.length > 0 && !F(f) && (p = p.replace(/[0-9]/g, "●"));
  };
  return F(l) == !0 && r(), F(i) && e(), p;
}
const Gt = { key: 0 }, Ut = {
  key: 0,
  class: "spinner-container"
}, qt = { class: "spinner-wrapper" }, Wt = {
  id: "icnSpinnerFull",
  class: "is-size-1 spinner"
}, Kt = {
  key: 1,
  class: "spinner-overlay-container"
}, Ht = { class: "spinner-wrapper" }, jt = {
  id: "icnSpinnerFull",
  class: "is-size-1 spinner"
}, Qt = {
  key: 3,
  class: "has-text-centered mt-6"
}, Xt = { id: "icnSpinner" }, Jt = {
  __name: "Spinner",
  props: {
    isVisible: Boolean,
    type: {
      type: String,
      default: "raw",
      required: !0,
      validator(t, l) {
        return ["raw", "list-loading", "fullscreen", "fullscreen-overlay"].includes(t);
      }
    },
    message: {
      type: String,
      default: "[[awaiting_message]]"
    },
    rawSize: {
      type: Number,
      default: 24
    }
  },
  setup(t) {
    return (l, c) => t.isVisible ? (s(), n("div", Gt, [
      t.type == "fullscreen" ? (s(), n("div", Ut, [
        a("div", qt, [
          a("span", Wt, [
            S(g(W), { class: "spinning icon-size-3" })
          ]),
          a("span", null, y(l.$t(t.message)), 1)
        ])
      ])) : t.type == "fullscreen-overlay" ? (s(), n("div", Kt, [
        a("div", Ht, [
          a("span", jt, [
            S(g(W), { class: "spinning icon-size-3" })
          ]),
          a("span", null, y(l.$t(t.message)), 1)
        ])
      ])) : t.type == "raw" ? (s(), B(g(W), {
        key: 2,
        class: "spinning lucide-default-size",
        size: t.rawSize
      }, null, 8, ["size"])) : t.type == "list-loading" ? (s(), n("div", Qt, [
        a("span", Xt, [
          S(g(W), { class: "spinning icon-size-2" })
        ])
      ])) : h("", !0)
    ])) : h("", !0);
  }
}, Yt = ["src", "alt"], Zt = ["title"], es = {
  key: 1,
  tabindex: "0",
  class: "otp is-size-1"
}, ts = {
  key: 0,
  class: "mt-3 is-size-4"
}, ss = ["title"], os = { key: 1 }, ns = {
  key: 1,
  class: "mt-3"
}, Ds = {
  __name: "OtpDisplay",
  props: {
    twofaccountService: {
      required: !0
    },
    preferences: {
      type: Object,
      required: !0
    },
    can_showNextOtp: {
      type: Boolean,
      default: !0
    },
    can_autoCloseTimeout: {
      type: Boolean,
      default: !0
    },
    iconPathPrefix: String,
    accountParams: {
      type: Object,
      default(t) {
        return {
          otp_type: "",
          account: "",
          service: "",
          icon: "",
          secret: "",
          digits: null,
          algorithm: "",
          period: null,
          counter: null,
          image: ""
        };
      }
    },
    uri: String
  },
  emits: [
    "please-close-me",
    "please-clear-search",
    "please-update-active-group",
    "kickme",
    "increment-hotp",
    "error",
    "validation-error",
    "otp-copied-to-clipboard"
  ],
  setup(t, { expose: l, emit: c }) {
    const { t: i } = ye.global, { copy: f, copied: p } = me({ legacy: !0 }), r = c, e = t, o = e.twofaccountService, u = b(null), m = b(null), d = b({
      otp_type: "",
      account: "",
      service: "",
      icon: "",
      secret: "",
      digits: null,
      algorithm: "",
      period: null,
      counter: null,
      image: ""
    }), T = b(!1), O = b(""), V = M(() => fe(
      O,
      e.preferences.formatPassword,
      e.preferences.formatPasswordBy,
      e.preferences.showOtpAsDot,
      T
    )), C = b(""), A = M(() => fe(
      C,
      e.preferences.formatPassword,
      e.preferences.formatPasswordBy,
      e.preferences.showOtpAsDot,
      T
    )), L = b(null), R = b(!1), G = b(!1), ae = b("0"), ie = b(null), le = H("dotsController"), J = H("dots"), ke = H("otpSpanTag");
    ve(
      () => e.accountParams.icon,
      (k) => {
        k != null && (d.value.icon = k);
      }
    );
    const ge = async (k) => {
      if (T.value = !1, d.value.otp_type = e.accountParams.otp_type, d.value.account = e.accountParams.account, d.value.service = e.accountParams.service, d.value.icon = e.accountParams.icon, d.value.secret = e.accountParams.secret, d.value.digits = e.accountParams.digits, d.value.algorithm = e.accountParams.algorithm, d.value.period = e.accountParams.period, d.value.counter = e.accountParams.counter, ue(), k) {
        u.value = k;
        const { data: v } = await o.get(u.value);
        d.value.service = v.service, d.value.account = v.account, d.value.icon = v.icon, d.value.otp_type = v.otp_type, q(v.otp_type) && v.counter && (d.value.counter = v.counter);
      } else e.uri ? (m.value = e.uri, d.value.otp_type = e.uri.slice(0, 15).toLowerCase() === "otpauth://totp/" ? "totp" : "hotp") : (e.accountParams.secret ? !U(d.value.otp_type) && !q(d.value.otp_type) && r("error", new Error(i("error.not_a_supported_otp_type"))) : r("error", new Error(i("error.cannot_create_otp_without_secret"))), U(d.value.otp_type) && (R.value = !0));
      try {
        await re(), $e(), e.preferences.getOtpOnRequest && e.can_autoCloseTimeout && parseInt(e.preferences.autoCloseTimeout) > 0 && be();
      } catch {
        Y();
      }
    };
    async function re() {
      e.can_showNextOtp && C.value ? (O.value = C.value, C.value = "", J.value.turnOff(), Z(0)) : ue(), await _e().then((k) => {
        let v = k.data;
        O.value = v.password, C.value = e.can_showNextOtp && Object.prototype.hasOwnProperty.call(v, "next_password") ? v.next_password : "", e.preferences.copyOtpOnDisplay && D(v.password), U(v.otp_type) ? (L.value = v.generated_at, d.value.period = v.period, R.value = !0, pe().then(() => {
          le.value.startStepping();
        })) : q(v.otp_type) && (d.value.counter = v.counter, r("increment-hotp", { nextHotpCounter: v.counter, nextUri: v.uri }));
      }).catch((k) => {
        k.response.status === 422 && r("validation-error", k.response);
      }).finally(() => {
        G.value = !1;
      });
    }
    function ue() {
      G.value = !0, J.value.turnOff();
    }
    function _e() {
      return u.value ? o.getOtpById(u.value) : m.value ? o.getOtpByUri(m.value) : o.getOtpByParams(d.value);
    }
    function ce() {
      r("please-close-me"), T.value = !1, Y();
    }
    function Y() {
      u.value = d.value.counter = L.value = null, d.value.service = d.value.account = d.value.icon = d.value.otp_type = d.value.secret = "", O.value = "... ...", C.value = "", R.value = !1, clearTimeout(ie.value), le.value?.reset();
    }
    function $e() {
      pe().then(() => {
        ke.value?.focus();
      });
    }
    function D(k, v) {
      if (f(k.replace(/ /g, "")), p) {
        if (e.preferences.kickUserAfter == -1 && (v || !1) === !0 ? r("kickme") : e.preferences.closeOtpOnCopy && (v || !1) === !0 && ce(), e.preferences.clearSearchOnCopy && r("please-clear-search"), e.preferences.viewDefaultGroupOnCopy) {
          const x = e.preferences.defaultGroup == -1 ? e.preferences.activeGroup : e.preferences.defaultGroup;
          r("please-update-active-group", x);
        }
        r("otp-copied-to-clipboard");
      }
    }
    function U(k) {
      return k === "totp" || k === "steamtotp";
    }
    function q(k) {
      return k === "hotp";
    }
    function Z(k) {
      J.value.turnOn(k), ae.value = "is-opacity-" + k;
    }
    l({
      show: ge,
      clearOTP: Y
    });
    function be() {
      let k = parseInt(e.preferences.autoCloseTimeout);
      ie.value = setTimeout(function() {
        ce();
      }, k * 60 * 1e3);
    }
    return (k, v) => (s(), n("div", null, [
      a("figure", {
        class: w(["image is-64x64", { "no-icon": !d.value.icon }]),
        style: { display: "inline-flex" }
      }, [
        d.value.icon ? (s(), n("img", {
          key: 0,
          src: t.iconPathPrefix + "/storage/icons/" + d.value.icon,
          alt: k.$t("alttext.icon_to_illustrate_the_account")
        }, null, 8, Yt)) : h("", !0)
      ], 2),
      S(g(ne), null, {
        default: $(({ mode: x }) => [
          a("p", {
            class: w(["is-size-4 has-ellipsis", x == "dark" ? "has-text-grey-light" : "has-text-grey"])
          }, y(d.value.service), 3),
          a("p", {
            class: w(["is-size-6 has-ellipsis", x == "dark" ? "has-text-grey" : "has-text-grey-light"])
          }, y(d.value.account), 3),
          a("p", null, [
            G.value ? (s(), n("span", es, [
              S(Jt, {
                isVisible: G.value,
                type: "raw"
              }, null, 8, ["isVisible"])
            ])) : (s(), n("span", {
              key: 0,
              id: "otp",
              role: "log",
              ref: "otpSpanTag",
              tabindex: "0",
              class: w(["otp is-size-1 is-clickable px-3", x == "dark" ? "has-text-white" : "has-text-grey-dark"]),
              onClick: v[0] || (v[0] = (we) => D(O.value, !0)),
              onKeyup: v[1] || (v[1] = j((we) => D(O.value, !0), ["enter"])),
              title: k.$t("tooltip.copy_to_clipboard")
            }, y(V.value), 43, Zt))
          ])
        ]),
        _: 1
      }),
      ee(S(Xe, { ref: "dots" }, null, 512), [
        [de, U(d.value.otp_type)]
      ]),
      ee(a("p", null, y(k.$t("field.counter")) + ": " + y(d.value.counter), 513), [
        [de, q(d.value.otp_type)]
      ]),
      e.can_showNextOtp && e.preferences.showNextOtp ? (s(), n("p", ts, [
        C.value ? (s(), n("span", {
          key: 0,
          class: w(["is-clickable", ae.value]),
          onClick: v[2] || (v[2] = (x) => D(C.value, !0)),
          onKeyup: v[3] || (v[3] = j((x) => D(C.value, !0), ["enter"])),
          title: k.$t("tooltip.copy_next_password")
        }, y(A.value), 43, ss)) : (s(), n("span", os, " "))
      ])) : h("", !0),
      e.preferences.showOtpAsDot && e.preferences.revealDottedOTP ? (s(), n("p", ns, [
        a("button", {
          type: "button",
          class: "button is-ghost has-text-grey-dark",
          onClick: v[4] || (v[4] = E((x) => T.value = !T.value, ["stop"]))
        }, [
          T.value ? (s(), B(g(Ge), { key: 0 })) : (s(), B(g(Ue), { key: 1 }))
        ])
      ])) : h("", !0),
      R.value ? (s(), B(Je, {
        key: 2,
        period: d.value.period,
        generated_at: L.value,
        autostart: !1,
        onSteppingEnded: v[5] || (v[5] = (x) => re()),
        onSteppingStarted: v[6] || (v[6] = (x) => Z(x)),
        onSteppedUp: v[7] || (v[7] = (x) => Z(x)),
        ref: "dotsController"
      }, null, 8, ["period", "generated_at"])) : h("", !0)
    ]));
  }
}, as = { class: "block" }, is = {
  key: 0,
  class: "block has-text-link"
}, ls = {
  type: "button",
  class: "button is-link is-outlined is-rounded"
}, rs = { class: "icon is-small" }, Fs = {
  __name: "QrContentDisplay",
  props: {
    qrContent: String,
    isCompact: {
      type: Boolean,
      default: !1
    }
  },
  setup(t) {
    const { copy: l } = me({ legacy: !0 }), { t: c } = ye.global, i = he();
    function f(e) {
      var o = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/, u = new RegExp(o);
      return u.test(e);
    }
    function p(e) {
      const o = document.createElement("a");
      o.setAttribute("href", e), o.dispatchEvent(new MouseEvent("click", { view: window, bubbles: !0, cancelable: !0 }));
    }
    function r(e) {
      l(e), i.success({ text: c("notification.copied_to_clipboard") });
    }
    return (e, o) => (s(), n(P, null, [
      o[2] || (o[2] = a("div", { class: "too-bad" }, null, -1)),
      a("div", as, y(e.$t("error.data_of_qrcode_is_not_valid_URI")), 1),
      a("div", {
        class: w(["block light-or-darker", { "mb-6": !t.isCompact }])
      }, y(t.qrContent ? t.qrContent : "[" + e.$t("message.nothing") + "]"), 3),
      t.qrContent ? (s(), n("div", is, [
        a("button", {
          type: "button",
          class: "button is-link is-outlined is-rounded",
          onClick: o[0] || (o[0] = E((u) => r(t.qrContent), ["stop"]))
        }, y(e.$t("label.copy_to_clipboard")), 1)
      ])) : h("", !0),
      f(t.qrContent) ? (s(), n("div", {
        key: 1,
        class: "block has-text-link",
        onClick: o[1] || (o[1] = (u) => p(t.qrContent))
      }, [
        a("button", ls, [
          a("span", null, y(e.$t("label.open_in_browser")), 1),
          a("span", rs, [
            S(g(qe))
          ])
        ])
      ])) : h("", !0)
    ], 64));
  }
}, us = {
  __name: "ResponsiveWidthWrapper",
  props: {
    isActive: {
      type: Boolean,
      default: !0
    },
    isCompact: {
      type: Boolean,
      default: !1
    }
  },
  setup(t) {
    return (l, c) => t.isActive ? (s(), n("div", {
      key: 0,
      class: w(["container", t.isCompact ? "pt-3" : "form-column"])
    }, [
      _(l.$slots, "default")
    ], 2)) : _(l.$slots, "default", { key: 1 });
  }
}, cs = {
  role: "search",
  class: "field"
}, ds = { class: "control has-icons-right" }, ps = ["aria-label", "title", "placeholder"], fs = { class: "icon is-small is-right" }, vs = ["title"], Is = {
  __name: "SearchBox",
  props: /* @__PURE__ */ I({
    hasNoBackground: {
      type: Boolean,
      default: !1
    },
    placeholder: String,
    isSmall: {
      type: Boolean,
      default: !1
    }
  }, {
    keyword: {},
    keywordModifiers: {}
  }),
  emits: /* @__PURE__ */ I(["cleared"], ["update:keyword"]),
  setup(t, { emit: l }) {
    const c = z(t, "keyword"), i = H("searchInput"), f = l;
    Q(() => {
      document.addEventListener("keydown", p), document.addEventListener("keypress", e);
    }), oe(() => {
      document.removeEventListener("keydown", p), document.removeEventListener("keypress", e);
    });
    function p(o) {
      o.key === "f" && (o.ctrlKey || o.metaKey) && (o.preventDefault(), i.value?.focus());
    }
    function r() {
      c.value = "", f("cleared");
    }
    function e(o) {
      o.key === "Enter" || o.code === "Space" || o.key === " " || (c.value = o.key, i.value?.setSelectionRange(1, 1), i.value?.focus(), o.preventDefault());
    }
    return (o, u) => (s(), n("div", cs, [
      a("div", ds, [
        ee(a("input", {
          "onUpdate:modelValue": u[0] || (u[0] = (m) => c.value = m),
          onKeyup: [
            u[1] || (u[1] = j(E((m) => {
              r(), m.target.blur();
            }, ["prevent"]), ["esc"])),
            u[2] || (u[2] = j(E((m) => m.target.blur(), ["prevent"]), ["enter"]))
          ],
          onKeypress: u[3] || (u[3] = E(() => {
          }, ["stop"])),
          ref: "searchInput",
          id: "txtSearch",
          type: "search",
          tabindex: "1",
          "aria-label": o.$t("label.search"),
          title: o.$t("tooltip.search"),
          placeholder: t.placeholder,
          class: w(["input is-rounded is-search", { "has-no-background": t.hasNoBackground, "is-small": t.isSmall }])
        }, null, 42, ps), [
          [Ce, c.value]
        ]),
        a("span", fs, [
          c.value != "" ? (s(), n("button", {
            key: 0,
            type: "button",
            id: "btnClearSearch",
            tabindex: "1",
            title: o.$t("tooltip.clear_search"),
            class: "clear-selection delete",
            onClick: r
          }, null, 8, vs)) : (s(), B(g(We), {
            key: 1,
            class: "mr-2 icon-size-1"
          }))
        ])
      ])
    ]));
  }
}, ms = {
  key: 0,
  class: "stack-header"
}, hs = {
  key: 1,
  class: "stack-subheader"
}, ys = { class: "stack-content" }, ks = {
  key: 3,
  class: "stack-footer"
}, Vs = {
  __name: "StackLayout",
  props: {
    isVerticalCentered: {
      type: Boolean,
      default: !1
    },
    shouldGrow: {
      type: Boolean,
      default: !0
    }
  },
  setup(t) {
    return (l, c) => (s(), n("div", {
      class: w(["stack is-flex is-flex-direction-column", { "is-max-height": t.shouldGrow }])
    }, [
      l.$slots.header ? (s(), n("div", ms, [
        _(l.$slots, "header")
      ])) : h("", !0),
      l.$slots.subheader ? (s(), n("div", hs, [
        _(l.$slots, "subheader")
      ])) : h("", !0),
      l.$slots.content ? (s(), n("div", {
        key: 2,
        class: w(["stack-content-wrapper", { "is-align-content-center": t.isVerticalCentered, "is-flex-grow-1": t.shouldGrow }])
      }, [
        a("div", ys, [
          _(l.$slots, "content")
        ])
      ], 2)) : h("", !0),
      l.$slots.footer ? (s(), n("div", ks, [
        _(l.$slots, "footer")
      ])) : h("", !0)
    ], 2));
  }
}, gs = { class: "options-header" }, _s = { class: "tabs is-centered is-fullwidth" }, $s = { role: "menubar" }, bs = ["id", "onClick"], ws = { class: "is-invisible-tablet" }, Ss = { class: "is-size-7-mobile" }, Rs = {
  __name: "TabBar",
  props: {
    tabs: {
      type: Array
    },
    activeTab: {
      type: String,
      default: ""
    },
    isResponsive: {
      type: Boolean,
      default: !0
    }
  },
  emits: ["tab-selected"],
  setup(t, { emit: l }) {
    const c = t, i = l;
    return (f, p) => (s(), n("div", gs, [
      S(us, {
        "is-active": t.isResponsive,
        "is-compact": !0
      }, {
        default: $(() => [
          a("nav", _s, [
            a("ul", $s, [
              (s(!0), n(P, null, se(c.tabs, (r) => (s(), n("li", {
                key: r.view,
                class: w({ "is-active": r.view === c.activeTab })
              }, [
                a("a", {
                  id: r.id,
                  onClick: (e) => i("tab-selected", r.view),
                  class: "is-flex-direction-column"
                }, [
                  a("span", ws, [
                    S(g(ft), {
                      name: r.icon,
                      strokeWidth: 1
                    }, null, 8, ["name"])
                  ]),
                  a("span", Ss, y(f.$t(r.name)), 1)
                ], 8, bs)
              ], 2))), 128))
            ])
          ])
        ]),
        _: 1
      }, 8, ["is-active"])
    ]));
  }
}, Cs = {
  key: 1,
  class: "main"
}, Gs = {
  __name: "VueFooter",
  setup(t) {
    const l = K("2fauth", {
      context: "webapp",
      version: "x.y.z",
      config: {
        proxyAuth: !1,
        proxyLogoutUrl: null
      }
    }), c = b(!1);
    return (i, f) => (s(), n(P, null, [
      c.value == !0 ? (s(), n("div", {
        key: 0,
        onClick: f[0] || (f[0] = (p) => c.value = !1),
        class: "footer-overlay"
      })) : h("", !0),
      g(l).context == "webext" ? (s(), n("footer", Cs, [
        S(te, null, {
          default: $(() => [
            _(i.$slots, "default")
          ]),
          submenu: $(() => [
            _(i.$slots, "submenu")
          ]),
          subpart: $(() => [
            _(i.$slots, "subpart")
          ]),
          _: 3
        })
      ])) : g(l).context == "webapp" ? (s(), n("footer", {
        key: 2,
        class: w(["main", { menu: c.value }])
      }, [
        S(te, {
          "show-menu": c.value,
          "onUpdate:showMenu": f[1] || (f[1] = (p) => c.value = p)
        }, {
          default: $(() => [
            _(i.$slots, "default")
          ]),
          submenu: $(() => [
            _(i.$slots, "submenu")
          ]),
          subpart: $(() => [
            _(i.$slots, "subpart")
          ]),
          _: 3
        }, 8, ["show-menu"])
      ], 2)) : h("", !0)
    ], 64));
  }
};
export {
  Xe as Dots,
  Je as DotsController,
  Ls as FormWrapper,
  Ns as GroupSwitch,
  Es as Kicker,
  ft as LucideGenericIcon,
  zs as Modal,
  Ds as OtpDisplay,
  Fs as QrContentDisplay,
  us as ResponsiveWidthWrapper,
  Is as SearchBox,
  Jt as Spinner,
  Vs as StackLayout,
  Rs as TabBar,
  Gs as VueFooter,
  te as VueFooterContent,
  he as useNotify,
  fe as useVisiblePassword
};
